import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useColors } from '../../../hooks/useColors';

const MAX_DISPLAY_LENGTH = 50;

const JsonFieldDisplay = ({ value, maxLength = MAX_DISPLAY_LENGTH, className = '' }) => {
  const { semantic } = useColors();
  
  // Parse JSON string if needed and create preview
  const getDisplayValue = useCallback(() => {
    try {
      // Parse if it's a string
      const parsed = typeof value === 'string' ? JSON.parse(value) : value;
      
      // Handle different types
      if (Array.isArray(parsed)) {
        return `[${parsed.length} items]`;
      }
      
      if (typeof parsed === 'object' && parsed !== null) {
        const keys = Object.keys(parsed);
        if (keys.length === 0) return '{}';
        
        // Show first key and count of remaining
        const remaining = keys.length - 1;
        const preview = `{ ${keys[0]}: ${JSON.stringify(parsed[keys[0]])}${remaining > 0 ? `, +${remaining} more` : '' } }`;
        return preview.length <= maxLength ? preview : preview.substring(0, maxLength) + '...';
      }
      
      // For primitive values
      const formatted = JSON.stringify(parsed);
      return formatted.length <= maxLength ? formatted : formatted.substring(0, maxLength) + '...';
    } catch (e) {
      console.warn('Error formatting JSON:', e);
      return String(value).substring(0, maxLength) + '...';
    }
  }, [value, maxLength]);

  return (
    <span className={`font-mono text-sm ${semantic.formText} ${className}`}>
      {getDisplayValue()}
    </span>
  );
};

JsonFieldDisplay.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object
  ]).isRequired,
  maxLength: PropTypes.number,
  className: PropTypes.string
};

export default JsonFieldDisplay;

